<template>
  <v-form>
    <!-- プロパティモーダル -->
    <v-dialog v-model="dialogVisible" max-width="300px" persistent>
      <v-card>
        <v-card-title>プロパティ編集</v-card-title>
        <v-card-text>
          <!-- プロパティ追加ボタン -->
          <v-btn @click="openEditProperty()">＋プロパティ追加</v-btn>
          <!-- プロパティ一覧 -->
          <!-- 検索候補リスト -->
          <v-list v-if="filteredProperties.length" style="margin-top: 10px">
            <v-list-item
              v-for="(property, index) in filteredProperties.filter(property => property.propertyName !== 'ステータス' && property.propertyName !== 'コメント')"
              :key="index" @click="openEditProperty(property)">
              <v-list-item-content class="d-flex align-center">
                <v-list-item-title>{{
                  property.propertyName
                }}</v-list-item-title>
                <!-- 必須マークを表示 -->
                <v-icon v-if="property.required" color="red" small class="custom-icon-margin">mdi-alert-circle
                </v-icon>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn @click="closeProperty()">閉じる</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- プロパティ追加モーダル -->
    <v-dialog v-model="editPropertyDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">{{
          this.selectedProperty.propertyName
        }}</v-card-title>

        <!-- エラーメッセージ -->
        <v-alert v-if="propertyErrorMessages.name || propertyErrorMessages.type" type="error">
          <div v-if="propertyErrorMessages.name">
            {{ propertyErrorMessages.name }}
          </div>
          <div v-if="propertyErrorMessages.type">
            {{ propertyErrorMessages.type }}
          </div>
        </v-alert>

        <v-card-text>
          <!-- プロパティ名入力 -->
          <v-text-field v-model="selectedProperty.name" :rules="propertyNameRule" :error-messages="propertyErrorMessages.name ? [propertyErrorMessages.name] : []
            " label="プロパティ名"></v-text-field>
          <!-- プロパティタイプ選択 -->

          <v-select v-if="!propertyFlg" v-model="selectedProperty.type" :error-messages="propertyErrorMessages.type ? [propertyErrorMessages.type] : []
            " :items="propertyTypes" label="プロパティタイプ"></v-select>
          <!-- セレクトボックス用のオプション設定（タイプがセレクトの場合） -->
          <v-if v-if="selectedProperty.type === 'セレクト'">
            <v-btn @click="openEditOption()" color="primary">＋オプション追加</v-btn>
            <!-- 現在の選択肢を表示 -->
            <v-list>
              <v-list-item-group v-if="
                selectedProperty.options &&
                selectedProperty.options.length > 0
              ">
                <v-list-item v-for="(option, index) in selectedProperty.options" :key="index"
                  @click="openEditOption(index)">
                  <v-list-item-content>
                    <v-list-item-title>{{ option }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action> </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-if>
          <!-- プロパティ必須項目 -->
          <!-- <v-checkbox v-if="!propertyFlg" v-model="selectedProperty.required" label="必須項目"></v-checkbox> -->
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="saveEditProperty()">{{
            propertyBtnName
          }}</v-btn>
          <v-btn v-if="newPropertyFlg" color="red" @click="removeProperty()">削除</v-btn>
          <v-btn color="secondary" @click="closeEditProperty()">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- オプション編集モーダル -->
    <v-dialog v-model="editOptionDialog" max-width="400px">
      <!-- エラーメッセージ -->
      <v-alert v-if="optionErrorMessage" type="error">
        {{ optionErrorMessage }}
      </v-alert>
      <v-card>
        <v-card-text>
          <v-text-field v-model="selectedOption.name" :rules="optionNameRule"
            :error-messages="optionErrorMessage ? [optionErrorMessage] : []" label="新しいオプションを追加"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <!-- 追加ボタンと削除ボタンの表示切り替え -->
          <v-btn color="primary" @click="saveEditOption()">{{
            optionBtnName
          }}</v-btn>
          <v-btn v-if="newOptionFlg" color="red" @click="removeOption()">削除</v-btn>
          <v-btn color="secondary" @click="closeEditOption()">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import propertyEdit from "@/api/propertyEdit";

export default {
  props: {
    selectedCardId: Number, // カードサイドバーのカードID
    propertyDialog: Boolean, // 親からのダイアログ表示状態
    tableId: Number,
    data: Object,
  },
  data() {
    return {
      authUserId: localStorage.getItem("authUserId"),
      sessionKey: localStorage.getItem("sessionKey"),
      tebleId: null,
      isRequired: null,
      dialogVisible: true,
      editPropertyDialog: false, // プロパティ編集画面表示状態
      editOptionDialog: false, // オプション編集画面表示状態
      propertySearch: "", // プロパティ検索用
      propertyName: "", // プロパティ名
      propertyType: "", // プロパティタイプ
      property: {},
      propertyId: null,
      propertyFlg: "",
      propertyTypes: [
        "数値",
        "小数",
        "日付",
        "時間",
        "テキスト",
        "ファイル",
        "セレクト",
      ], // プロパティタイプの選択肢
      selectedProperty: {
        // 選択されたプロパティの値
        name: "",
        type: "",
        required: false,
        options: [],
        index: null,
      },
      propertyNameRule: [
        (value) => {
          if (value == null || value == "") {
            return;
          } else if (value.length > 20) {
            return "20文字以下で入力してください";
          }
          return true;
        },
      ],
      optionNameRule: [
        (value) => {
          if (value == null || value == "") {
            return;
          } else if (value.length > 20) {
            return "20文字以下で入力してください";
          }
          return true;
        },
      ],
      selectedOption: { id: "", name: "", index: null }, // 選択されたオプションの値
      optionBtnName: null,
      propertyBtnName: null,
      newPropertyFlg: true, // 新規プロパティ作成時
      newOptionFlg: true, // 新規オプション作成時
      filteredProperties: [], // 検索プロパティ格納用
      propertyErrorMessages: { name: "", type: "" },
      optionErrorMessage: "", // エラーメッセージ用
    };
  },
  watch: {
    dialogVisible(newVal) {
      console.log("dialogVisibleの変更:", newVal);
      if (newVal === true) {
        this.dialogVisible = newVal;
        console.log("テーブルID:", this.tableId);
      }
    },
    data: {
      handler(newData) {
        console.log("dataの変更:", newData);
        this.filterProp();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.filterProp();
  },
  methods: {

    filterProp() {
      console.log("sideBarからのプロパティ:", this.data);

      // Proxyオブジェクトの構造からデータを抽出
      const propertiesArray = this.data.data[0].properties || [];

      // 必要な情報を抽出
      this.filteredProperties = propertiesArray
        .map((item) => {
          const property = item.property || {};
          return {
            propertyId: property.propertyId,
            propertyName: property.propertyName,
            propertyType: property.propertyType,
          };
        })
        .filter(
          (item) => item.propertyId && item.propertyName && item.propertyType
        ); // 全てのキーが存在する場合のみ格納

      console.log("CardEditのプロパティ情報3:", this.filteredProperties);
    },
    propertiesArray() {
      // データが適切に存在する場合のみ配列を返す
      if (
        this.data &&
        Array.isArray(this.data.data) &&
        this.data.data[0]?.properties &&
        Array.isArray(this.data.data[0].properties)
      ) {
        return this.data.data[0].properties;
      }
      console.warn(
        "propertiesが見つからない、または不正なデータ形式です:",
        this.data
      );
      return []; // デフォルト値
    },
    // プロパティ画面を閉じる
    closeProperty() {
      this.dialogVisible = false;
      this.$emit("update:dialogVisible", false);
    },
    // プロパティ編集画面を表示
    openEditProperty(property) {
      // this.selectedProperty = null;
      if (property) {
        (this.propertyFlg = true),
          // 編集モードの場合: 既存プロパティの情報を格納
          (this.selectedProperty = { ...property });
        console.log("プロパティ中身", property);
        if (
          !this.selectedProperty.options ||
          this.selectedProperty.options.length === 0
        ) {
          // options が存在しないか、空の配列の場合、デフォルトの値を設定
          this.selectedProperty.options = ["未着手", "進行中", "完了"];
        } else {
          // options が既に存在する場合、そのまま表示
          console.log("選択されたオプション:", this.selectedProperty.options);
        }
        this.propertyBtnName = "保存"; // 編集時には「保存」ボタン
        this.newPropertyFlg = true; // 編集時には「削除」ボタンを表示
      } else {
        (this.propertyFlg = false),
          // 新規追加モードの場合
          (this.selectedProperty = {
            name: "",
            type: "",
            options: ["未着手", "進行中", "完了"], // 新しいオプション配列
          });
        this.propertyBtnName = "追加"; // 新規追加時には「追加」ボタン
        this.newPropertyFlg = false; // 新規追加時には削除ボタンを非表示
      }
      this.editPropertyDialog = true;
    },
    // プロパティ編集画面を非表示
    closeEditProperty() {
      // エラーメッセージをリセット
      this.propertyErrorMessages.name = "";
      this.propertyErrorMessages.type = "";
      this.editPropertyDialog = false;

      // 親コンポーネントにプロパティリストの再取得を依頼
      this.refreshProperties();

      // プロパティ編集画面を再度開く
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },

    // プロパティ情報を保存する（後でバックエンドへ送信など）
    saveEditProperty() {
      if (!this.selectedProperty) {
        console.error("selectedPropertyが未定義です");
        return;
      }

      this.propertyErrorMessages.name = "";
      this.propertyErrorMessages.type = "";

      // プロパティ名が空でないことをチェック
      if (!this.selectedProperty.name) {
        this.propertyErrorMessages.name = "プロパティ名は必須です"; // プロパティ名のエラーメッセージ
      }

      if (!this.selectedProperty.name.trim()) {
        this.propertyErrorMessages.name = "正しいプロパティ名を入力してください"; // プロパティ名のエラーメッセージ
      }

      // プロパティタイプが空でないことをチェック
      if (!this.selectedProperty.type && this.propertyFlg == false) {
        this.propertyErrorMessages.type = "プロパティタイプは必須です"; // プロパティタイプのエラーメッセージ
      }

      // 両方が空の場合は処理を中断
      if (this.propertyErrorMessages.name || this.propertyErrorMessages.type) {
        return; // 保存処理を中断
      }

      if (this.propertyBtnName == "保存") {
        // properties 配列の該当するインデックスに selectedProperty を保存
        this.propertiesArray[this.selectedProperty.index] = {
          ...this.selectedProperty,
        };

        this.editPropertyName();
        console.log("保存されたプロパティN: ", this.selectedProperty.name);
        console.log("保存されたプロパティT: ", this.selectedProperty.type);
        console.log("保存されたプロパティiR: ", this.isRequired);
        console.log("保存されたプロパティiR: ", this.propertyId);
      } else {
        // 新しいプロパティを追加
        this.saveAddProperty();
        console.log(
          "新しいプロパティが追加されました: ",
          this.selectedProperty
        );
      }

      this.closeEditProperty();
      this.refreshProperties();
    },
    async saveAddProperty() {
      // 既存のプロパティ名と重複していないかチェック
      const duplication = this.filteredProperties.some(
        (property) => property.propertyName === this.selectedProperty.name
      );
      if (duplication) {
        alert("既に存在するプロパティ名です");
        return;
      }
      if (this.selectedProperty.type == "数値") {
        this.propertyType = "1";
      } else if (this.selectedProperty.type == "小数") {
        this.propertyType = "2";
      } else if (this.selectedProperty.type == "日付") {
        this.propertyType = "3";
      } else if (this.selectedProperty.type == "時間") {
        this.propertyType = "4";
      } else if (this.selectedProperty.type == "テキスト") {
        this.propertyType = "5";
      } else if (this.selectedProperty.type == "ファイル") {
        this.propertyType = "6";
      } else if (this.selectedProperty.type == "セレクト") {
        this.propertyType = "7";
      }
      if (this.selectedProperty.required == false) {
        this.isRequired = 0;
      } else {
        this.isRequired = 1;
      }
      try {
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        const staffName = localStorage.getItem("staffName");
        await propertyEdit.addProperty(
          this.tableId,
          this.selectedProperty.name,
          this.propertyType,
          this.isRequired,
          authUserId,
          sessionKey,
          staffName,
          this.selectedProperty.options
        );
        this.refreshProperties();
        this.$emit("triggerSearch"); //ボードビュー画面更新処理を追加
        this.$emit("refreshCardSidebar", this.selectedCardId);
      } catch (error) {
        console.error("プロパティ追加に失敗:", error.message);
      }
    },
    async editPropertyName() {
      if (this.propertyTypes == "テキスト") {
        this.propertyType = "1";
      } else if (this.propertyTypes == "数値") {
        this.propertyType = "2";
      } else if (this.propertyTypes == "日付") {
        this.propertyType = "3";
      } else {
        this.propertyType = "4";
      }
      if (this.selectedProperty.required == false) {
        this.isRequired = 0;
      } else {
        this.isRequired = 1;
      }
      if (this.selectedProperty.propertyId) {
        this.propertyId = this.selectedProperty.propertyId;
      }
      try {
        const staffName = localStorage.getItem("staffName");
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        await propertyEdit.editProperty(
          authUserId,
          sessionKey,
          this.selectedProperty.propertyId,
          this.selectedProperty.name,
          staffName
        );
        this.refreshProperties();
        this.$emit("triggerSearch"); //ボードビュー画面更新処理を追加
        this.$emit("triggerCardSidbar"); //カードサイドバー画面更新処理を追加
        this.$emit("refreshCardSidebar", this.selectedCardId);

      } catch (error) {
        console.error("プロパティ追加に失敗:", error.message);
      }
    },

    // API通信でプロパティを削除
    removeProperty() {
      //取得したindexのプロパティをもとにisDeleted=1にする処理
      this.isDeletedEqualsOne();
      this.$emit("refreshCardSidebar", this.selectedCardId);
      this.closeEditProperty();
      this.refreshProperties();
      this.$emit("triggerSearch")
    },
    refreshProperties() {
      // 親コンポーネントにプロパティ更新リクエストを送信
      this.$emit("refreshProperties");
    },
    async isDeletedEqualsOne() {
      console.log("削除していく", this.selectedProperty.propertyId);
      try {
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        const staffName = localStorage.getItem("staffName");
        await propertyEdit.deleteProperty(
          this.tableId,
          this.selectedProperty.propertyId,
          authUserId,
          sessionKey,
          staffName
        );
        await this.$emit("triggerSearch"); //ボードビュー画面更新処理を追加
        await this.$emit("triggerCardSidbar"); //カードサイドバー画面更新処理を追加
      } catch (error) {
        console.error("プロパティ削除に失敗:", error.message);
      }
    },

    // オプション編集画面を表示
    openEditOption(index) {
      if (index != null && index !== undefined && index !== "") {
        // 編集するオプションを設定
        this.selectedOption.name = this.selectedProperty.options[index];
        this.selectedOption.index = index;
        this.newOptionFlg = true; // 編集モード（削除ボタン表示/保存ボタンにする）
        if (this.newOptionFlg == true) {
          this.optionBtnName = "保存"; // 編集時は保存ボタン
        }
      } else {
        // 新しいオプションを追加する場合
        this.selectedOption.name = "";
        this.selectedOption.index = null;
        this.newOptionFlg = false; // 新規追加モード（追加ボタンにする）
        if (this.newOptionFlg == false) {
          this.optionBtnName = "追加"; // 新規追加時は追加ボタン
        }
      }
      this.editOptionDialog = true; // オプション編集ダイアログを表示
    },
    // オプション編集ダイアログを閉じる
    closeEditOption() {
      this.editOptionDialog = false;
      this.selectedOption = { name: "", index: null }; // フィールドリセット
      this.optionErrorMessage = "";
    },
    // オプション情報を保存
    saveEditOption() {
      if (!this.selectedOption.name) {
        this.optionErrorMessage = "オプション名は必須です"; // エラーメッセージを設定
        return; // 保存処理を中断
      }
      const invalidCharRegex = /\\\\|[,:]/;
      if (invalidCharRegex.test(this.selectedOption.name)) {
      alert("プロパティ名に「\\\\」「,」「:」は使用できません。");
      return;
      }
      if (this.selectedOption.index !== null) {
        this.selectedProperty.options[this.selectedOption.index] =
          this.selectedOption.name;
      } else {
        this.selectedProperty.options.push(this.selectedOption.name);
      }
      this.closeEditOption();
    },
    // オプションを削除
    removeOption() {
      if (this.selectedOption.index !== null) {
        // インデックスが指定されている場合、そのオプションを削除
        this.selectedProperty.options.splice(this.selectedOption.index, 1);
      }
      this.closeEditOption();
    },
  },
};
</script>

<style scoped>
.form-header {
  background-color: #ffffff;
  /* 背景色を白色に */
  height: 150px;
  /* 高さを指定して色が表示される領域を作成 */
}

.custom-icon-margin {
  position: relative;
  margin-left: 150px;
  font-size: 18px;
  /* mdi-circleを小さくする */
}
</style>
